import { type ReactElement } from 'react';
import { generateSourceSet, getRemoteSrc } from '@utils/imageLoader.ts';
import type { ID } from '@funnellab/shared/src/dtos/base';

export type ImageProps = {
  sizes?: string;
  width?: number;
  height?: number;
  alt?: string;
  className?: string;
  aspectRatio?: number;
} & ({ src: string } | { asset: ID });

export default function Image(props: ImageProps): ReactElement {
  let src: string;
  let alt: string | undefined;
  if ('src' in props) {
    src = props.src;
    alt = props.alt;
  } else if ('asset' in props) {
    src = getRemoteSrc(props.asset);
    alt = props.asset;
    /* istanbul ignore next */
  } else {
    console.error('Image component received invalid props', props);
    throw new Error('Invalid image props');
  }

  return (
    <img
      src={src}
      srcSet={generateSourceSet(src, undefined, props.aspectRatio)}
      alt={alt}
      className={props.className}
      sizes={props.sizes ?? '100vw'}
      width={props.width}
      height={props.height}
    />
  );
}
